var jq = jQuery.noConflict();

var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    asset_url = companyVars.asset_url,
    website_base_url = companyVars.website_base_url,
    ir_base_url = companyVars.ir_base_url,
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey,
    isQmod = companyVars.isQmod;

// Fires on click or enter keypress
jq.fn.accessibleClick = function (handler) {
    jq(this).on('click keyup', function (event) {
        if (event.type === 'keyup') {
            var code = event.which;
            // Don't consider it a click if we don't press enter or spacebar
            if ((code !== 32) && (code !== 13)) {
                return false;
            }
        }
        handler.call(this, event);
    });
};
    
var captchaIDs = {}; // Holds all hCaptcha elements so that we can use the correct response when there are multiples on a page
function hCaptchaOnLoad () {
    // Add hcaptcha to all forms on a page
     jq('.h-captcha').each(function () {
        var form = jq(this).closest('form');
        window.captchaIDs[form.id] = hcaptcha.render(this.id, {
            "sitekey" : window.hCaptchaSiteKey,
            "callback": function (token) {
                jq('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response',
                    value: token
                }).appendTo(form);
                form.submit();
            }
        });
    }); 
}

// Main document ready scripts
jq(document).ready(function () {
    // Pagination
    const paginationMobile = jq('#pagination--mobile');
    if (paginationMobile.length) {
        jq(this).find('#pagination--mobile-select').change(function() {
            var selectedPage = jq(this).val();
            location.href = encodeURI(selectedPage);
        });
    }

    // Add noopener to all links that open in a new tab.
    jq('a[target="_blank"]').each(function () {
        var linkRel = jq(this).attr('rel');
        if (!linkRel || (linkRel && linkRel.indexOf('noopener') == -1)) {
            var newRel = linkRel === undefined ? '' : linkRel;
            newRel += linkRel && linkRel.length ? ' noopener' : 'noopener';
            jq(this).attr('rel', newRel);
        }
        // Add descriptive text for screen readers if there's not already a title attr set
        if (this.getAttribute('title') === null) {
            this.setAttribute('title', 'Opens in a new window');
        }
    });
    addRequiredAsteriskToLabels();
    
    // Scroll more home hero button
    var scrollMore = document.getElementById("scroll-more");
    if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();
            var target = jq(this).closest(".home-hero").siblings(".module").first();
            
            // make scroll distance larger for mobile devices, when the navigation bar is not in a fixed position
            let header = document.querySelector("#header");
            var animationDistance = (window.innerWidth <= 991 && header && window.getComputedStyle(header).getPropertyValue("position") !== "fixed") ? 0 : jq("#header").height(); 
            jq("html,body").animate({
                scrollTop: target.offset().top - animationDistance
            }, "slow");
        });
        
        // add a resize event listener to recheck the screen width
        window.addEventListener("resize", function() {
            // make scroll distance larger for mobile devices, when the navigation bar is not in a fixed position
            let header = document.querySelector("#header");
            var animationDistance = (window.innerWidth <= 991 && header && window.getComputedStyle(header).getPropertyValue("position") !== "fixed") ? 0 : jq("#header").height(); 
            jq(scrollMore).data("animation-distance", animationDistance);
        });
    }

    
    jq(".mobile-nav-trigger").click(function (){
        jq(".main-nav").css("height", "auto");
    });
    
    jq("#header.affixed").affix({
        offset:{
            top: 1
        }
    });
    
    //Video Play/Pause Buttons
    var videoBtns = document.querySelectorAll('.video-control-btn');
    videoBtns.forEach(function(el) {
        // get video id from attribute 'data-target'
        var targetVideo = document.getElementById(el.dataset.target);
        if (targetVideo) {
          jq(el).click(function(e) {
            if (targetVideo.paused) {
              targetVideo.play();
              //Controls don't show by default to match designs
              //On play, we need to hide the designed play/pause button and shows the controls
              if (targetVideo.classList.contains('show-controls-on-play')) {
                el.classList.add('hide');  
                targetVideo.setAttribute('controls', '');
              }
              el.setAttribute('aria-label', 'Pause Video');
            } else {
              targetVideo.pause();
              el.setAttribute('aria-label', 'Play Video');
            }
            el.classList.toggle('paused');
          });
        }
    });
    
    //Circle Stat with Percentage Animation
    var divPercentage = jq(".stats-row-w-percents");
    if(divPercentage.length) {
        jq(document).bind("scroll", function (ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq(".stats-row-w-percents").offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq(".stats-row-w-percents .stat").each(function () {
                    var percDiv = jq(this).find(".number"),
                    svgElm = jq(this).find(".circle"),
                    percentNumber = jq(this).attr("data-percent");
                    svgElm.attr("stroke-dasharray", percentNumber + ", 100");
                    svgElm.addClass("active");
                    jq({percentage: 0}).stop(true).animate({percentage: percentNumber}, {
                        duration : 2000,
                        step: function () {
                        var percentageVal = Math.round(this.percentage);
                        percDiv.text(percentageVal + "%");
                    }
                    }).promise().done(function () {
                        percDiv.text(percentNumber + "%");
                    });
                });
                jq(document).unbind("scroll");
            }
        });
    }
    
    var subNav = jq(".sub-navigation.affixed");
    if(subNav.length) {
        jq(subNav).affix({
            offset: { 
                top: jq(".sub-navigation").offset().top - jq("#header").outerHeight()
            }
        });
    }

    var menuRight = document.getElementById("mobile-nav"),
    showRight = document.getElementById("showRight");
    
    jq.fn.openMobileRightMenu = function() {
        toggleMenuKeybind();
        jq(".mobile-nav-trigger").toggleClass("active");
        jq("body").toggleClass("push-to-left");
        jq(menuRight).toggleClass("cbp-spmenu-open");
        disableOther("showRight");
    }

    function disableOther(button) {
        if (button !== "showRight") {
            jq(showRight).toggleClass("disabled");
        }
    }
    
    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
     function toggleMenuKeybind() {
        var $body = jq('body');    
        if ($body.hasClass('push-to-left')) {
            $body.off("keydown");
        } else {
            $body.on("keydown", function (e) {
                if (e.which == 27) {
                    jq(".main-nav").toggleClass("active");
                    jq(showRight).toggleClass('active');
                    jq("body").toggleClass("push-to-left");
                    jq(menuRight).toggleClass("cbp-spmenu-open");
                    disableOther("showRight");
                    $body.off("keydown");
                }
            });
        }
    }

    // Basic Form Validation
    var validator = jq(".validate-form");
    validator.each(function () {
        var $form = jq(this);
        var formID = $form.attr('id');
        jq(this).validate({
            rules: {
                password_confirm: {
                    equalTo: "#password",
                    messages: {
                        equalTo: "Passwords must be the same"
                    }
                }
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.parent());
                element[0].scrollIntoView({ behavior: 'instant', block: 'center' });
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            },
            // Scroll and focus on the 1st error input after submitting an invalid form 
            invalidHandler: function(event, validator) {
                if (validator.errorList.length >= 1) {
                    let errorElement = validator.errorList[0].element;
                    errorElement.scrollIntoView({ behavior: 'instant', block: 'center' });
                    errorElement.focus();
                }
            }
        });
    });
    
    jq.validator.methods.email = function (value, element) {
      return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
    }
    
    jq(".fancybox").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "600"
    });
    jq(".fancybox-sec-filing").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "900"
    });
    
    jq(".fancybox-bio").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "0",
        afterShow: function() {
            jq(".fancybox-close-small").attr("title", "Close bio modal");
        }
    });
    
    jq(".fancybox-modal").fancybox({
        width: 970,
        autoSize: false,
        height: "auto"
    });
    
    jq(".fancybox\\.iframe").fancybox({
        type: "iframe",
        iframe : {
            css : {
                width : "80%",
                maxWidth: "1024px",
            }
        }
    });
    
    //File input
    var fileInput = jq(".file-text input");
    fileInput.change(function (e){
        $this = jq(this);
        var val = $this.val().split("\\");
        var length = val.length;
        var filename = val[length-1];
        jq(this).parent(".file-text").children(".text-wrapper").text(filename);
    });

    // SEC Filing Filters - auto submit form
    jq("#sec-filing-filter select").on("change", function (e) {
        jq(this).closest("form").submit(); 
    });
    
    var $filterSelect = jq(".row-filter .eq-select");
    if ($filterSelect.length) {
        $filterSelect.on("change", function () {
            var url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
            var query = "";
            jq(".row-filter .eq-select").each(function () {
                var prefix = "&";
                if (query.length === 0) {
                    prefix = "?";
                }
                if (jq(this).val() != -1) {
                    query += prefix + jq(this).attr("name") + "=" + jq(this).val();
                }
            });
            url = url + query;
            if (!query) {
            	var full_url = url + "?year=" + jq(this).val();
            	if (window.location.href != full_url) {
            		window.location.href = full_url;
            	}
            } else {
            	if (window.location.href != url) {
            		window.location.href = url;
            	}
            }
       });
    }
    
    // Resources module
    if (jq(".module-resources-page").length) {
        var viewModel = new ViewModel(JSON.parse(document.getElementById("resourcesVm").innerText));
    }
    
    // News slider
    if (jq(".news-slider").length) {
        jq(".news-slider").slick(JSON.parse(document.getElementById("newsSlickOptions").innerText));
    }

    // SEC Filings expand
    jq(".spr-expandable").hide();
    jq(".spr-toggle-expandable").click(function () {
    	jq(this).next(".spr-expandable").toggle("blind");
    	jq(this).toggleClass('expanded');
    	if (jq(this).hasClass('expanded')) {
    	    jq(this).attr('aria-pressed', true);   
    	} else {
    	    jq(this).attr('aria-pressed', false);
    	}
    });
    
    // Crisis Messaging
    var $majorAnnouncement = jq('#majorAnnouncement');
    var majorAnnouncementCookieName = "eqMajorAnnouncement";
    if ($majorAnnouncement.length) {
        var majorAnnouncementTimestamp = $majorAnnouncement.data("timestamp");
        var majorAnnouncementCookie = Cookies.get(majorAnnouncementCookieName);
        if (majorAnnouncementCookie != majorAnnouncementTimestamp) {
            jq.fancybox.open({
                src: '#majorAnnouncement',
                type: 'inline',
                touch: window.outerWidth < 768,
                beforeLoad: function () {
                    // Add an aria-label to the modal
                    var fancyboxContainer = jq.fancybox.getInstance().$refs.container;
                    fancyboxContainer.attr('aria-label', 'Announcement');
                },
                afterLoad: function () {
                    var fancyboxContainer = jq.fancybox.getInstance().$refs.container;
                    //Allow focus to modal container for accessibility
                    fancyboxContainer.find('.fancybox-content').attr('tabindex', 0);
                    // Remove main content visibility to screen readers
                    jq('.general-wrapper').attr('aria-hidden', true);
                },
                afterClose: function () {
                    jq('.general-wrapper').attr('aria-hidden', false);
                }
            });
            // Expires should be set to a number of days
            Cookies.set(majorAnnouncementCookieName, majorAnnouncementTimestamp, { secure: true, domain: window.location.hostname, expires: 7 });
        }
    }
    
    // Add Class to body if there is a scoll bar in the page
    if (jq(document).width() < jq(window).outerWidth()) { 
        jq('body').addClass('scrollbar');
    }
    
    // Fix accessibility issue for main navigation and sub navigation triggers on mobile
    function resize_events() {
        if (window.innerWidth <= 991) {
            jq('.mobile-nav-trigger').attr('tabindex', 0);
            jq('.mobile-sub-nav-trigger').attr('tabindex', 0);
            jq('.has-children ul li a').attr('tabindex', '-1');
            if (jq('.cbp-spmenu').hasClass('cbp-spmenu-open')) {
                jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', 0);
            } else {
                jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', -1);
            }
        } else {
            jq('.mobile-nav-trigger').attr('tabindex', '');
            jq('.mobile-sub-nav-trigger').attr('tabindex', '');
            jq('.has-children ul li a').attr('tabindex', '');
            jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', 0);
        }
    }
    // Call resize_events() on load
    resize_events();

    jq(window).resize(function(evt) {
        resize_events();
    });

    // Enable accessible clicking on mobile navs and subnavs
    jq('.mobile-nav-trigger').accessibleClick(function(evt) {
        evt.stopPropagation();
        jq(this).openMobileRightMenu();
        resize_events();
        return false;
    });
    
    //Detect window size change (switching to landscape on tablet
    var windowW = window.innerWidth;
    jq(window).resize(function() {
        windowW = window.innerWidth;
    });
    
    // Close mobile nav after selecting anchor link, make selected link use active class
    jq('.main-menu > .has-children > a').accessibleClick(function(e) {
        if (windowW >= 992) return;
        // Remove any existing active classes
        if (this.parentElement.classList.contains('active')) {
            this.parentElement.classList.remove('active');
            return;
        }
        jq('.main-menu > .has-children').each(function() {
            this.classList.remove('active');
        });
        this.parentElement.classList.add('active');
    });
    
    jq('#mobile-nav ul a').accessibleClick(function(e) {
        if (windowW >= 992) return;
        let navMenu = document.getElementById('mobile-nav');
        jq('#mobile-nav').toggleClass('cbp-spmenu-open');
        jq('body').toggleClass('push-to-left');
        jq('#showRight').toggleClass('active');
    });    

    jq('.mobile-sub-nav-trigger').accessibleClick(function(evt) {
        // We want to use the accessibleClick method so that the logic surrounding
        // keys is consistent; however, avoid recursion by causing an infinite click loop
        if (evt.type != 'click') {
            jq(this).click();
            return false;
        }
    });

    // Close mobile nav when selecting the darkened body background
    jq('.cbp-spmenu').accessibleClick(function(evt) {
        evt.stopPropagation();
    });
    jq('body').accessibleClick(function(evt) {
        if (this.classList.contains("push-to-left") ) {
            jq(this).openMobileRightMenu();
            resize_events();
            return false;
        };
    });    
    
    //Accessible click for Financial Results collapse elements
    jq('.quarterly-results [role=button]').accessibleClick(function(evt) {
        // We want to use the accessibleClick method so that the logic surrounding
        // keys is consistent; however, avoid recursion by causing an infinite click loop
        if (evt.type != 'click') {
            jq(this).click();
            return false;
        }
    });
    
    //Expand/Collapse all button for Financial Results
    var FinancialResultsExpandBtn = jq(".expand-all-quarters");
    var QuarterHeaders = jq(".quarterly-results .header");
    
    FinancialResultsExpandBtn.on('click', function(e) {
        //If elements are collapsed, expand the rest
        if (jq(this).text() == 'Expand All') {
            QuarterHeaders.filter(".collapsed").click();
        } else {
            //Otherwise collapse them all
            QuarterHeaders.filter(":not(collapsed)").click();
        }
    });
    
    QuarterHeaders.on("click", function(e) {
        if (FinancialResultsExpandBtn.length) {
            //Allow for collapse animation to complete
            //setTimeout(functionRef, delay, param1, param2)
            setTimeout(updateExpandBtnText, 200, FinancialResultsExpandBtn, ".quarterly-results .header");
        }
    });

    setTimeout(function() {
        jq('.qmod-legend li').each(function(i) {
            jq(this).attr('tabindex', 0);
            jq(this).accessibleClick(function(evt) {
                // We want to use the accessibleClick method so that the logic surrounding
                // keys is consistent; however, avoid recursion by causing an infinite click loop
                if (evt.type != 'click') {
                    jq(this).click();
                    return false;
                }
            });
        });
    }, 1000);
    
    // Allows upload of cover letter via styled link by triggering hidden upload/input field
    jq("#cover_letter").on('click', function(e) {
        e.preventDefault();
        jq("#upload_cover_letter:hidden").trigger('click');
    });
    
    // Make sure all registered marks are superscripts within the .general-wrapper, don't replace ones already superscripted.
    jq('.general-wrapper').find(':not(script, sup, .klaro.cm-as-context-notice *)').contents().filter(function() {
        return this.nodeType === 3;
    }).replaceWith(function() {
        return this.nodeValue.replace(/&reg;|®/gi, '<sup>&reg;</sup>');
    });

    /**
     * Elastic Search Tab Control
     **/
    const delay = 1000; // Time in milliseconds to wait before selecting tab

    // Get current URL
    let currentUrl = window.location.href;
    
    // Defining Active Tab variable
    if (currentUrl.includes("press-releases")) {
        var tabTarget = '#tab-press-releases';
    } else if (currentUrl.includes("sec-filings")) {
        var tabTarget = '#tab-all-sec-filings';
    } else {
        var tabTarget = '#tab-all';
    }
    
    // Execute click
    function selectTab() {
        setTimeout(() => {
            if ( jq(tabTarget).length ) {                                       
               jq(tabTarget).click();               
            }
        }, delay); 
    }    
    selectTab();

    // IR CTA preview page - Selecting banners to preview
    jq(".cta-preview").accessibleClick(function (e) {
        var banners = document.querySelectorAll(".ir-cta-test-container");
        banners.forEach(function(x) {
            x.style.display = 'none';
        });
        var default_banner = document.querySelector(".page-banner").parentElement
        default_banner.style.display = 'none';

        if (e.currentTarget.getAttribute("data-type") != "default") {
            let id = e.currentTarget.getAttribute("data-id");
            let targetBanner = jq(banners[id]);
            console.log(targetBanner[0]);
            targetBanner[0].style.display = 'flex';
        } else {
            default_banner.style.display = 'flex';            
        }
    });


    jq(".cta-preview-all").accessibleClick(function (e) {
        var show_banners = false;
        var banners = document.querySelectorAll(".ir-cta-test-container");
        banners.forEach(function(x) {
            if (!x.style.display || x.style.display == 'none') {
                show_banners = true;
            }
        });
        banners.forEach(function(x) {
            x.style.display = (show_banners) ? 'flex' : 'none';
        });
        var default_banner = document.querySelector(".page-banner").parentElement
        default_banner.style.display = (show_banners) ? 'flex' : 'none';
    });
   
   // Remove width from table headers with only a superscript  
    jq(".report .th").each(function(){
        // Extract the innerHTML
        const innerContent = jq(this).html().trim();
        
        // Use a regex to check if content matches <sup> with a number, asterisk, or these wrapped in square brackets
        const regex = /^<sup>(\[\d+\]|\d+|\[\*\]|\*)<\/sup>$/;
        if (regex.test(innerContent)) {
            jq(this).css({
                "width": "0%",
                "padding-left": "0"
            });
        }
    });
}); // end document.ready

// Adds asterisk to the labels of required form inputs
function addRequiredAsteriskToLabels() {
    jq("form .required").siblings("label").each(function () {
        var currentText = jq(this).text();
        jq(this).text(currentText + "*");
    });
}

//Smooth scroll to
function goToByScroll(id, callback) {
    jq("html,body").animate({
        scrollTop: jq(id).offset().top
    }, "slow", "swing", callback);
}
jq(".smooth").click(function () {
    goToByScroll(jq(this).attr("href"));
    return false;
});

//Check if any target elements are collapsed
function elementsAreCollapsed(selector = "[data-toggle='collapse']") {
    if (jq(selector + '.collapsed').length) {
        return true;
    } else {
        return false;
    }
}

function updateExpandBtnText(btn, collapseTarget) {
    if (!btn) {
        return;
    }
    if (elementsAreCollapsed(collapseTarget)) {
        btn.text('Expand All');
    } else {
        btn.text('Collapse All');
    }
}

// Checkbox Groups
var update_sec_checkboxes = function () {
    if (jq("#ir-sec-all").is(":checked")) {
        jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
    } else {
        jq(".ir-sec-sub").prop("disabled", false).prop("checked", false);
    }
}
jq("#ir-sec-all").change(update_sec_checkboxes);
if (jq("#ir-sec-all").is(":checked")) {
    jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
}

// Timeline
var $timelineEl = jq(".module-timeline");
if ($timelineEl.length) {
    var timeline = {
        resizePoints: function () {
            if (jq(window).outerWidth() < 768) return;
            jq(".point-wrapper").each(function () {
                  var point = jq(this).find(".point");
                  jq(this).css("height", point.outerHeight()/1.2);
                });
        }
    };
    // Once we"re done resizing, calculate the height for the points.
    var resizeTimer;
    jq(window).on("resize", function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(timeline.resizePoints, 250);
    });
    timeline.resizePoints();
}
//Add Class to body if page has scrollbar
jq(window).on("resize", function (e) {
    if (jq(document).width() < jq(window).outerWidth()) { 
        jq('body').addClass('scrollbar');
    } else {
        jq('body').removeClass('scrollbar');
    }
});
// Scroll More CTA templates
var scrollMore = document.getElementById("scroll-more-alt");
if (scrollMore) {
    jq(scrollMore).accessibleClick(function (e) {
        e.preventDefault();
        var target = jq("#scroll-more-anchor");
        jq("html,body").animate({
            scrollTop: target.offset().top - jq("#header").height()
        }, "slow");
    });
}
/**
 * Balance Sheet Page - Income Statement Page - Cash Flow Page
 * 
 * Replaces <a> elements within report table with <span> elements.
 * Removes 'href' and 'onclick' attributes from these elements &
 * adds the original 'a' class back to it.
 */
document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.report')) {
        // Find the table with class 'report'
        const reportTable = document.querySelector('.report');
        
        if (reportTable) {
            // Find all <td> elements containing <a> elements
            const tdWithLinks = reportTable.querySelectorAll('td a');
            
            // Transform each <a> into a <span>
            tdWithLinks.forEach(aElement => {
                const span = document.createElement('span');
                span.innerHTML = aElement.innerHTML;
                aElement.parentNode.replaceChild(span, aElement);
                span.classList.add("a");
            });
        }
    }
});